import { AnalyticsService } from './state/analytics.service';
import { Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IapService } from './state/iap.service';
import { UpdateService } from './state/update.service';
import { ExternalLinksService } from './services/external-links.service';
import { ThemeService } from './state/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonicModule, RouterOutlet, CommonModule],
  templateUrl: './app.component.html'
})
export class AppComponent {
  private readonly links = inject(ExternalLinksService);
  private readonly theme = inject(ThemeService); // applies html.avd-light on boot
  private readonly analytics = inject(AnalyticsService);
  constructor() {
    this.analytics.appOpen();
    this.links.install();
    inject(UpdateService).start();
    void inject(IapService).init(); // no-op on web / without a RevenueCat key
  }
}
